<template>  
  <v-row>
    <v-col
      xs="12"
    >        
      <v-expansion-panels>
        <v-expansion-panel
          v-for="attendant in $store.state.attending_stores"
          :key="attendant.id"
        >
          <v-expansion-panel-header>
            <v-layout justify-space-between style="width: 30%; max-width: 40%">
              <strong v-if="attendant.name">{{attendant.name}}</strong>
            </v-layout>

            <strong>{{attendant.email}}</strong>

          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card>
              <div>
                <v-card-text class="d-flex flex-no-wrap align-center justify-space-between">
                  <span>
                    Atende para as lojas
                  </span>

                  <div>
                    opções:
                    <v-btn @click="$emit('remove', attendant.id)" title="Remover" fab dark small color="error">
                      <v-icon dark>remove</v-icon>
                    </v-btn>
                    <v-btn @click="$emit('edit', attendant)" title="Editar" fab dark small color="cyan">
                      <v-icon dark>edit</v-icon>
                    </v-btn>
                  </div>
                </v-card-text>
              </div>

            </v-card>
            <v-list dense>
              <v-list-item
                v-for="s in attendant.attending_stores" :key="`${s.id}-${attendant.id}`">
                <v-list-item-content>
                  <v-layout justify-space-between>
                    <span>
                      {{s.name}}
                    </span>
                    
                    <span>
                      Status: {{(s.pivot.active) ? 'Ativa' : 'Desativada'}}
                    </span>
                  </v-layout>
                  
                  <v-list dense>
                    <v-list-item
                      v-for="c in s.pivot.contact_statuses" :key="`${s.id}-${c.id}`">
                      <v-list-item-content>
                        {{c.status}}
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>      
    </v-col>
  </v-row>  
</template>

<script>
  export default {
    name: 'List',

    created() {
      this.$store.dispatch('fetchAttendantStores');
    },

    data () {
      return {

      }
    }
  }
</script>

<style lang="css" scoped>
</style>